import { render, staticRenderFns } from "./PT600FirstAccessMailParts.vue?vue&type=template&id=47b52d84&"
import script from "./PT600FirstAccessMailParts.vue?vue&type=script&lang=js&"
export * from "./PT600FirstAccessMailParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports